<div class="inner-div">
  <img src="assets/images/taxi_frown.png" alt="sad-taxi">
  <p> {{ 'PAGE_NOT_FOUND' | translate }}</p>
</div>

